import { render, staticRenderFns } from "./CodePopup.vue?vue&type=template&id=6b531a16"
import script from "./CodePopup.vue?vue&type=script&lang=js"
export * from "./CodePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports